import { getCallable } from "../../_sdk/client";
import { apiName, endpoints } from "./endpoints";
import type {
    GetUserActionPermissionsRequest, GetUserActionPermissionsResponse,
    getUserPermissionsToResourceFolderRequest, getUserPermissionsToResourceFolderResponse,
    getUserPermissionsToResourceRequest, getUserPermissionsToResourceResponse
} from "./types";

export { apiName };

const getUserPermissionsToResourceFolder = getCallable<getUserPermissionsToResourceFolderRequest, getUserPermissionsToResourceFolderResponse>(
    apiName,
    "getUserPermissionsToResourceFolder",
    {
        ...endpoints.getUserPermissionsToResourceFolder,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/permissions/folder/${encodeURIComponent(request.resourceFolderId)}`,
                options: {
                    method: "GET"
                }
            };
        }
    }
);

const getUserPermissionsToResource = getCallable<getUserPermissionsToResourceRequest, getUserPermissionsToResourceResponse>(
    apiName,
    "getUserPermissionsToResource",
    {
        ...endpoints.getUserPermissionsToResource,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/permissions/resource/${encodeURIComponent(request.resourceType)}/${encodeURIComponent(request.resourceId)}`,
                options: {
                    method: "GET"
                }
            };
        }
    }
);

const getUserActionPermissions = getCallable<GetUserActionPermissionsRequest, GetUserActionPermissionsResponse>(
    apiName,
    "getUserActionPermissions",
    {
        ...endpoints.getUserActionPermissions,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/action-permissions`,
                options: {
                    method: "GET"
                }
            };
        }
    }
);

export const callables = {
    getUserPermissionsToResourceFolder,
    getUserPermissionsToResource,
    getUserActionPermissions
};
